import React, { ReactElement, useEffect, useMemo } from 'react';

import { getClassNames } from '../../../../utils/util';

import useTheme from '../../../../hooks/use-theme/useTheme';

import '../validation.scss';

type Props = {
  username: string;
  setValidUsername: (bool: boolean) => void;
};

const UsernameValidation = ({ username, setValidUsername }: Props): ReactElement => {
  // TODO: Update usage after migration
  const { pps } = useTheme();

  const hasNoSpace: boolean = useMemo((): boolean => !username.includes(' '), [username]);
  const hasThreeCharacters: boolean = useMemo((): boolean => username.length > 2, [username]);

  useEffect((): void => {
    setValidUsername(hasNoSpace && hasThreeCharacters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNoSpace, hasThreeCharacters]);

  return (
    <div className={getClassNames('validation', { pps })}>
      <div className="validation__rule">
        <span className={getClassNames('validation__rule__bullet', { satisfied: hasThreeCharacters, pps })} />
        <p className={getClassNames('validation__rule__text', { pps })}>At least 3 characters</p>
      </div>
      <span />
      <div className="validation__rule">
        <span className={getClassNames('validation__rule__bullet', { satisfied: hasNoSpace, pps })} />
        <p className={getClassNames('validation__rule__text', { pps })}>No spaces allowed</p>
      </div>
    </div>
  );
};

export default UsernameValidation;
